import { useState, useEffect, useContext } from 'react';
import { useHistory } from "react-router-dom";

import Title from '../components/ui/Title';
import UserContext from '../store/user-context';
import Button from '../components/ui/Button';
import Loading from '../components/layout/Loading';

import classes from './Leaderboard.module.scss';

function Leaderboard() {
    const userCtx = useContext(UserContext);
    const [isLoading, setIsLoading] = useState(true);
    const history = useHistory();

    const [allUsersDesc, setAllUsersDesc] = useState();

    const getAllUsers = async () => {
        try {
            const url = `https://movie-trivia-hijack-default-rtdb.firebaseio.com/users.json`;
            const response = await fetch(url);

            if (!response.ok) {
                throw new Error('Error: Something went wrong!');
            }
            const responseData = await response.json();

            const allUsers = [];

            for (const key in responseData) {
                allUsers.push({
                    id: key,
                    username: responseData[key].username,
                    email: responseData[key].email,
                    bollywood: responseData[key].bollywood,
                    hollywood: responseData[key].hollywood,
                    score: responseData[key].score
                });
            }

            if (allUsers && allUsers.length > 0) {
                const sortedList = allUsers.sort((a, b) => b.score - a.score)
                setAllUsersDesc(sortedList);                
            }
            setIsLoading(false);

        } catch (error) {
            console.log(error);
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getAllUsers();

    }, []);

    function gotoHomeHandler() {
        history.push('HomePage');
    }

    return (
        <div className={classes.leaderboard}>
            { isLoading && <Loading />}

            <Title>Leaderboard</Title>
            <br />
            <h2>WINNER</h2>
            <div className={classes['leaderboard__winner']}>
                {allUsersDesc && allUsersDesc[0]?.username}
            </div>
            <br />

            <div className={`${classes.gridTitleRow}`}>
                <span>Rank</span>
                <span>Username</span>
                <span>Levels</span>
                <span>Score</span>
            </div>

            { allUsersDesc &&
                allUsersDesc.map((userDetails, index) => {
                    return <div key={userDetails.id} className={userDetails.email === userCtx.email ? classes.gridSelfRow : classes.gridRow}>
                        <span>{index + 1}</span>
                        <span>{userDetails.username}</span>
                        <span>B-{userDetails.bollywood} / H-{userDetails.hollywood}</span>
                        <span>{userDetails.score}</span>
                    </div>
                })
            }

            <br />
            <div className={classes.homeBtnDiv}>
                <Button onBtnClick={gotoHomeHandler} >Home</Button>
            </div>
            <br /><br /><br /><br />
        </div>

    )
}

export default Leaderboard;
